import React from "react";
import Image from "next/image";
import NewsletterSignup from "@component/newsletter/NewsletterSignup";

const FooterTop = () => {
  return (
    <>
      {/* Newsletter Section */}
      <div className="bg-gradient-to-br from-emerald-600 to-emerald-800 py-12 lg:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left Content */}
            <div className="text-white">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-serif mb-4">
                Stay Ahead of the Curve!
              </h2>
              <p className="text-lg opacity-90 leading-7 mb-6">
                Join thousands of cubers who get exclusive access to:
              </p>
              <div className="space-y-3 mb-6">
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                  <span>Latest puzzle releases and restocks</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                  <span>Exclusive competition announcements</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                  <span>Personalized discounts and special offers</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                  <span>Cubing tips and tutorials from experts</span>
                </div>
              </div>              <div className="flex items-center space-x-4 text-sm opacity-75">
                <span>📧 Magic link subscription</span>
                <span>🔒 No spam guarantee</span>
                <span>📱 Mobile friendly</span>
              </div>
            </div>

            {/* Right Content - Newsletter Form */}
            <div className="flex justify-center lg:justify-end">
              <div className="w-full max-w-md">                <NewsletterSignup
                  variant="default"
                  title="Join Our Community"
                  description="Subscribe to latest offers, competition announcements, and personalized discount emails"
                  className="bg-white shadow-2xl"
                  useMagicLink={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Existing App Download Section */}
      <div
        id="downloadApp"
        className="bg-indigo-50 py-10 lg:py-16 bg-repeat bg-center overflow-hidden"
      >
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 md:gap-3 lg:gap-3 items-center">
            <div className="flex-grow hidden lg:flex md:flex md:justify-items-center lg:justify-start">
              <Image
                src="/app-download-img-left.png"
                alt="app download"
                width={500}
                height={394}
                className="block w-auto"
                placeholder="blur"
                blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </div>
            <div className="text-center">
              <h3 className="text-xl md:text-2xl lg:text-3xl font-bold font-serif mb-3">
                Get Your Puzzle Needs From CubeNation Store
              </h3>
              <p className="text-base opacity-90 leading-7">

                We have a large collection of 9000 Puzzles at your disposal. We primarily sell speedcubes and quality puzzles. If you are a speedcuber or puzzle enthusiast,
                you will find useful puzzles and accessories from us.
              </p>

            </div>
            <div className="md:hidden lg:block">
              <div className="flex-grow hidden lg:flex md:flex lg:justify-end">
                <Image
                  src="/app-download-img.png"
                  width={500}
                  height={394}
                  alt="app download"
                  className="block w-auto"
                  placeholder="blur"
                  blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                  style={{
                    maxWidth: "100%",
                    height: "auto"
                  }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterTop;
